<template>
  <div class="index">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Welcome {{ memberSessionArr.name }}!</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Dashboard</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <div class="form-group form-focus">
                  <div class="btn-group btn-block">
                    <button
                      style="min-width: auto;"
                      type="button"
                      class="btn add-btn btn-block"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span v-if="!isLoadingImage"
                        ><i class="fa fa-download"></i> Download Image</span
                      >
                      <span v-else>...</span>
                    </button>
                    <button
                      style="min-width: auto;"
                      type="button"
                      class="btn add-btn dropdown-toggle dropdown-toggle-split"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu">
                      <a
                        class="dropdown-item"
                        :disabled="isLoadingImage"
                        href="javascript:void(0)"
                        @click.prevent="downloadImagePNG()"
                        >PNG</a
                      >
                      <a
                        class="dropdown-item"
                        :disabled="isLoadingImage"
                        href="javascript:void(0)"
                        @click.prevent="downloadImageJPEG()"
                        >JPEG</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div ref="downloadImage">
            <div class="row">
              <div class="col-md-12">
                <TotalKeywords />
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="card card__custom-height">
                  <div class="card-body ">
                    <total-scrape-marketplace />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card card__custom-height">
                  <div class="card-body ">
                    <!-- Total Scrape per Status -->
                    <total-scrape-status />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="card">
                  <div class="card-body">
                    <TotalStatusPerMP mpId="shopee" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card">
                  <div class="card-body">
                    <TotalStatusPerMP mpId="tokopedia" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="card">
                  <div class="card-body">
                    <TotalStatusPerMP mpId="lazada" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card">
                  <div class="card-body">
                    <TotalStatusPerMP mpId="bukalapak" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="card">
                  <div class="card-body">
                    <TotalStatusPerMP mpId="tiktok" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <last-scrape />
            </div>
            <div class="col-md-6">
              <scrape-terjadwal />
            </div>
          </div>
          <!-- Statistics Widget -->
          <!-- <graph-sum-license /> -->

          <!-- /Statistics Widget -->
        </div>
        <!-- /Page Content -->
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
</template>
<script>
// import GraphSumLicense from "./components/graphSumLicense.vue";
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import TotalScrapeMarketplace from "./components/totalScrapeMarketplace";
import TotalScrapeStatus from "./components/totalScrapeStatus";
import TotalStatusPerMP from "./components/totalStatusPerMP";
import TotalKeywords from "./components/totalKeywords";
import LastScrape from "./components/lastScrape";
import ScrapeTerjadwal from "./components/scrapeTerjadwal";
import { nFormatter } from "@/utils/helper";
import { toPng, toJpeg } from "html-to-image";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    // GraphSumLicense
    TotalScrapeMarketplace,
    TotalScrapeStatus,
    LastScrape,
    ScrapeTerjadwal,
    TotalStatusPerMP,
    TotalKeywords
  },
  data() {
    return {
      isLoadingImage: false
    };
  },
  computed: {
    memberSessionArr() {
      return this.$store.state.login.memberSession;
    },
    numLicenseTotal() {
      return this.$store.state.member.numLicenseTotal;
    },
    numAgentTotal() {
      return this.$store.state.member.numAgentTotal;
    },
    numMessageTotal() {
      return this.$store.state.member.numMessageTotal;
    },
    numActiveVoucherTotal() {
      return this.$store.state.member.numActiveVoucherTotal;
    }
  },
  created() {
    // this.getLicenseTotal();
    // this.getAgentTotal();
    // this.getMessageTotal();
    // this.$store.dispatch("member/getActiveVoucherTotal");
  },
  mounted() {},
  methods: {
    nFormatter(value) {
      return nFormatter(value);
    },
    getMessageTotal() {
      let params = {};
      params = {
        provider: "whatsapp"
      };
      this.$store.dispatch("member/getMessageTotal", params);
    },
    getLicenseTotal() {
      this.$store.dispatch("member/getLicenseTotal");
    },
    getAgentTotal() {
      this.$store.dispatch("member/getAgentTotal");
    },
    async downloadImagePNG() {
      const el = this.$refs.downloadImage;
      const now = new Date();
      const unixTime = Math.floor(now.getTime() / 1000);

      if (el === null) {
        return;
      }

      this.isLoadingImage = true;

      await toPng(el, { backgroundColor: "#f7f7f7" })
        .then(dataUrl => {
          const link = document.createElement("a");
          link.download = `dashboard-monitoring-${unixTime}.png`;
          link.href = dataUrl;
          link.click();
        })
        .catch(err => {
          console.log(err);
        });

      this.isLoadingImage = false;
    },
    async downloadImageJPEG() {
      const el = this.$refs.downloadImage;
      const now = new Date();
      const unixTime = Math.floor(now.getTime() / 1000);

      if (el === null) {
        return;
      }

      this.isLoadingImage = true;

      await toJpeg(el, { backgroundColor: "#f7f7f7" })
        .then(dataUrl => {
          const link = document.createElement("a");
          link.download = `dashboard-monitoring-${unixTime}.jpeg`;
          link.href = dataUrl;
          link.click();
        })
        .catch(err => {
          console.log(err);
        });

      this.isLoadingImage = false;
    }
  },
  name: "index"
};
</script>
<style>
.card__custom-height.card {
  min-height: 95%;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/index.vue